//broadcastChanel
export let BCEvents = /*#__PURE__*/function (BCEvents) {
  BCEvents["MESSAGE"] = "message";
  return BCEvents;
}({});

//SharedWorkerGlobalScope events
export let EV_TYPES = /*#__PURE__*/function (EV_TYPES) {
  EV_TYPES["CONNECT"] = "connect";
  EV_TYPES["MESSAGE"] = "message";
  return EV_TYPES;
}({});